<template>
<!-- ログイン 入力フォーム -->
<div id="login">
    <div id="content">
        <div class="inner center">
			<h2>ログイン</h2>
			<div class="login_area"><!-- 入力 -->
				<h3>ID・パスワードをお持ちの方</h3>
				<dl id="form_area">
					<div class="flex justifycont-c">
					<dt><label for="username" class="form_label">ID</label></dt>
					<dd><input type="text" name="username" v-model="login.loginid" id="username"></dd>
					</div>
					<div class="flex justifycont-c">
					<dt><label for="password" class="form_label">パスワード</label></dt>
					<dd><input type="password" name="password" v-model="login.password" id="password"></dd>
					</div>
				</dl>
				<div class="login_button"><!-- ボタン -->
					<button class="btn_login" @click="Log_in"><fa icon="user" class="icon fa-user"></fa>&ensp;ログイン</button>
				</div>
				<p class="error">{{error_name}}</p>
				<div class="hosoku">
					<p class="hosoku_title">
						<fa icon="caret-right" class="fas fa-caret-right fa-fw"/><router-link to="/Password">パスワードを忘れた方はこちら</router-link>
					</p>
					<p class="hosoku_title"><fa icon="caret-right" class="fas fa-caret-right fa-fw"/>IDを忘れた方</p>
					<p class="hosoku_text">青森市ボランティアセンターまでお問い合わせください。</p>
					<p class="hosoku_text">お問合せ先：017-723-1340</p>
				</div>
			</div>
        </div>
		<div class="center">
			<h3>ID・パスワードをお持ちでない方</h3>
			<p>体験ボランティアの申込には新規登録が必要です。</p>
			<router-link to="/katudo-touroku/first"><button class="btn_new"><fa icon="user-plus" class="icon fa-user-plus"></fa>&ensp;新規登録</button></router-link>
		</div>
    </div>
</div>
</template>

<script>
// import {computed} from 'vue';
import { inject } from 'vue';
import router from "../router";
export default {
    name: 'Login',  //コンポーネントに名前をつける
    data() {
        return {
			error_name: "",
        };
    },
	setup () {
		const { login, isLogin } = inject('loginstate');
		return {
			login,
			isLogin,
		}
	},
	methods: {
		// gotoTop() {
		// 	if (this.login.user_type) {
		// 		this.error_name = ""
		// 	} else {
		// 		setTimeout(() => {
		// 			this.error_name = "ログイン情報が正しくありません。";
		// 		},500);
		// 	}
		// },
		async Log_in() {
			const code = await this.isLogin();
			if(code) {
				this.error_name = "ログイン情報が正しくありません。";
			} else {
				this.error_name = "";
				router.push({ path: '/'});
			}
		}
	}
};
</script>

<style scoped>
.login_area {
	width: 50%;
	margin: 0 auto;
}
@media screen and (max-width: 767px) {
	.login_area {
		width: 100%;
	}
}
.form_area dt {
    float:left;
    width: 100px;
    /* margin: 0 0 10px; */
}
.form_area dd {
    margin: 0 0 10px;
}

.form_area label.form_label {
    font-weight: bold;
    font-size: 1rem;
}
.form_area label.label_sub {
    font-weight: normal;
    font-size: 1rem;
}
.form_area input {
    font-size: 1rem;
}
</style>